import { Divider, Stack, Typography } from "@mui/material";
import { DefaultHealthRecordCardTypeProps } from "../HealthRecordCard";
import { useTranslation } from "react-i18next";

interface HealthRecordCardTypePathologyTestProps {
  type: string;
  name: string;
  description: string;
  dateTime: string;
  details?: {
    data: Array<{
      value: string;
      type: string;
    }>;
  };
}

interface Props extends DefaultHealthRecordCardTypeProps {
  data: HealthRecordCardTypePathologyTestProps;
}

export default function HealthRecordCardTypePathologyTest({
  data: { details },
  hasDetails,
}: Props) {
  const { t } = useTranslation();

  function findOrderNumberInDetails(
    data: Array<{
      value: string;
      type: string;
    }>
  ) {
    const orderNumber = data.find((item) => {
      if (item.type.toLowerCase() === "ordernumber") {
        return item.value;
      }
    });
    return orderNumber?.value || "";
  }

  return (
    <Stack spacing={2}>
      <Divider />
      {hasDetails && (
        <Stack spacing={0.5}>
          <Typography variant="body2">
            {t("PathologyOrderSummary.orderNumber.title")}
          </Typography>
          <Typography variant="body2">
            {findOrderNumberInDetails(details?.data || [])}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
}
